const newsInner = document.querySelector(".news--inner");
const src = "/_data/newsRu.json";
const news = document.createDocumentFragment;

function createNewsCard({ img, imgWebp, title, subtitle, data, link }) {
  const newsCard = document.createElement("section");
  newsCard.classList = "news-card";

  //IMG
  const newsImg = document.createElement("div");
  newsImg.classList = "news-card__img";
  const newsImgInner = `<picture><source type="image/webp" srcset=${imgWebp} /><img src=${img} alt="news" /></picture>`;
  newsImg.innerHTML = newsImgInner;

  //CardContent
  const newsCardContent = document.createElement("div");
  newsCardContent.classList = "news-card__content";

  //Title
  const newsTitle = document.createElement("h3");
  newsTitle.classList = "news-card__title";
  newsTitle.innerHTML = title;

  //Subtitle
  const newsSubtitle = document.createElement("p");
  newsSubtitle.classList = "news-card__text";
  newsSubtitle.textContent = subtitle;

  //Card Meta
  const newsCardMeta = document.createElement("div");
  newsCardMeta.classList = "news-card__meta";
  //Time
  const newsCardTime = document.createElement("span");
  newsCardTime.classList = "news-card__time";
  newsCardTime.innerHTML = data;
  //Link
  const newsCardLink = document.createElement("a");
  newsCardLink.classList = "news-card__link";
  newsCardLink.textContent = "Подробнее";
  newsCardLink.href = link;

  //appends
  newsCardMeta.append(newsCardTime);
  newsCardMeta.append(newsCardLink);

  newsCardContent.appendChild(newsTitle);
  newsCardContent.appendChild(newsSubtitle);
  newsCardContent.appendChild(newsCardMeta);

  newsCard.appendChild(newsImg);
  newsCard.appendChild(newsCardContent);

  return newsCard;
}

getNews(src);

async function getNews(src) {
  await fetch(src)
    .then((news) => news.json())
    .then((news) => {
      const firstThreeNews = news.slice(0, 3);

      firstThreeNews.map((el) => newsInner.append(createNewsCard(el)));
    });
}
